import React from "react";
import './Home.css';
import LogoDropDown from "../LogoDropDown/logoDropDown";

function HomeShop() {
    return (

        <div className="com-container">
            <div className='com-header'>
                <LogoDropDown activeItems={["Schmodel", ".shop", ".club"]} animation={true} />
            </div>
            <div className="com-main">
                Preloved luxury goods from your <br/>
                favourite fashion icons.<br/>
                <br/>
                Exclusive products from locally <br/>
                inspired fashion and beauty brands.<br/>
                <br/>
                Coming AW2026
            </div>
            <div className="com-footer"/>
        </div>
    );
}

export default HomeShop;
